import script from "./UFines.vue?vue&type=script&setup=true&lang=ts"
export * from "./UFines.vue?vue&type=script&setup=true&lang=ts"

import "./UFines.vue?vue&type=style&index=0&id=4ae149bc&lang=css"

const __exports__ = script;

export default __exports__